/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-05-14 08:34:02
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-05-15 11:05:18
 * @FilePath: \website\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from '@/App.vue'
import router from './router'

import '@/router/permission'
import cpt from '@/components/register-cpt'
import cptOption from '@/components/register-option'

import TDesign from 'tdesign-vue-next';
import 'tdesign-vue-next/es/style/index.css';
import '@/assets/font/theme.css'


import VueGridLayout from 'vue-grid-layout'

import DataVVue3 from '@kjgl77/datav-vue3'

import wx from 'weixin-js-sdk'



import Editor from 'bin-editor-next';
import 'brace/ext/emmet'
import 'brace/ext/language_tools'
import 'brace/mode/json'
import 'brace/snippets/json'
import 'brace/theme/vibrant_ink'

import '@/assets/font/custom-font.css'
import '@/assets/css/index.css'

// import 'tdesign-mobile-vue/dist/tdesign.css'

const app = createApp(App);
const pinia = createPinia(App)
// app.config.globalProperties.$echarts = echarts;
app.config.globalProperties.$wxsdk = wx

// app.config.errorHandler = (error) => {
//    console.error(
//     `错误： 
//       ${error}
//     `

//   )
// }

app.use(router);  
app.use(DataVVue3)
app.use(TDesign);

app.use(VueGridLayout)
app.use(pinia)
for (const key in cpt) {
  const realKey = key.replaceAll('_', '-')
  app.component(realKey, cpt[key])
}
for (const key in cptOption) {
  const realKey = key.replaceAll('_', '-')
  app.component(realKey, cptOption[key])
}
app.component(Editor.name, Editor)


window.app = app

app.mount('#app')






